module.exports = __webpack_public_path__ + "static/unlimited_pets_store-b0dd4f0c559082fd4d6f9f927fc7a100.png";